import { useContext } from "react";
import { useInfiniteQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";

export default function useInfiniteLibrary(query) {
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const fetchLibrary = ({ pageParam }) =>
    api
      .postSearchLibrary({
        ...query,
        start: pageParam * 20,
        projectId,
        sessionId,
      })
      .then((data) => data.data);

  const queryKey =
    query.a === "contextId"
      ? ["library", "contextId", query.contextId, projectId]
      : ["library", query.a, projectId];

  const { data, hasNextPage, fetchNextPage, refetch, status } =
    useInfiniteQuery(queryKey, fetchLibrary, {
      getNextPageParam: (lastPage, pages) => {
        const stop = lastPage?.list?.length === 0;
        const nextPage = pages.length + 1;
        return !stop ? nextPage : undefined;
      },
    });
  const getError = () => {
    let isError = false;
    if (data?.pages) {
      const status = data.pages.map((page) => page.status);
      if (status.includes(0) || status.includes(-1)) isError = true;
    }
    return isError;
  };

  return {
    library: data?.pages,
    isLibraryLoading: status === "loading",
    isLibraryError: getError(),
    hasNextPage,
    fetchNextPage,
    refetchLibrary: refetch,
  };
}
